// ZOD
import * as z from 'zod';
import { PageType, PageZod, PageSlugZod, PageSlugType } from '@/views/Page/PageType';

// Strapi
import { blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getPage = async (slug: string): Promise<PageType> =>
  fetchStrapiContentWithBlocks(`/api/pages/${slug}`, PageZod, { blocks, seo }, 'Page');

export const getPages = async (): Promise<Array<PageSlugType>> => {
  const pageSize = 10;
  const response = await client.get('/api/pages', {
    params: {
      fields: ['slug'],
      populate: {
        seo,
      },
      pagination: {
        page: 1,
        pageSize,
      },
    },
  });

  const totalPages = response.data?.meta?.pagination.pageCount || 1;
  const allData = [...(response.data?.data ?? [])];

  try {
    if (totalPages > 1) {
      const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) =>
        client.get('/api/pages', {
          params: {
            fields: ['slug'],
            populate: {
              seo,
            },
            pagination: { page: i + 2, pageSize },
          },
        }),
      );
      const results = await Promise.all(pagePromises);
      results.forEach((r) => allData.push(...(r.data?.data || [])));
    }

    return z.array(PageSlugZod).parseAsync(allData);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Pages structure:\n${formatZodError(error, allData)}`);
    }
    throw error;
  }
};
